import _ from 'lodash'

/**
 * Setne informace o uživateli do objectu a vrátí ho
 * @param {*} userData
 * @param {*} token
 * @return {*}
 */
export function setCurrentUserObject(userData, token) {
    return {
        token: token,
        id: _.get(userData, 'id', null),
        username: _.get(userData, 'username', ''),
        name: _.get(userData, 'name', ''),
        surname: _.get(userData, 'surname', ''),
        company: _.get(userData, 'company', {}),
        settings: _.get(userData, 'settings', {}),
        groups: _.get(userData, 'groups', []),
    }
}
